import { BaseStoredItem } from "./BaseStoredItem";
import { CollectionDesignation } from "../../common/interfaces";
import { coreLibraryInitialised } from "../../common/util";

export class StoredCollectionDesignation extends BaseStoredItem<CollectionDesignation> {
  async get(): Promise<CollectionDesignation> {
    const designation = await this.retrieveData();

    if (designation) {
      return Promise.resolve(designation);
    }

    let defaultCollectionDesignation = CollectionDesignation.All;

    if (coreLibraryInitialised()) {
      // @ts-ignore
      const sessionValue = await GlamCornerCore.gcSession.getSessionValues("customerInfo");

      if (sessionValue && sessionValue.customerInfo) {
        defaultCollectionDesignation = sessionValue.customerInfo.customerGroup.startsWith("subscription-")
          ? CollectionDesignation.Subscription
          : CollectionDesignation.OnDemand;
      }

      return Promise.resolve(defaultCollectionDesignation);
    }

    return Promise.resolve(CollectionDesignation.All);
  }

  storageKey(): string {
    return "designation";
  }
}
